import { useState } from 'react';
import S from './TabsStyles';

type Props = {
  tabs: any;
  activeId?: string;
  onChange?: any;
};

function Tabs({
  tabs, onChange, activeId,
}: Props): JSX.Element {
  const [activeTab, toggleActiveTab] = useState(activeId || tabs[0]?.id);
  const handleClick = (e: any): void => {
    toggleActiveTab(e.target.getAttribute('id'));
    if (onChange) {
      onChange(e.target.getAttribute('id'));
    }
  };

  return (
    <S.ItemWrapper className="tabs">
      <ol className="tab-list">
        {tabs?.map((tab: any) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
          <li
            className={activeTab === tab.id ? 'tab-list-active' : 'tab-list-item'}
            id={tab.id}
            key={tab.id}
            onClick={handleClick}
          >
            {tab.label}
          </li>
        ))}
      </ol>
      <div className="tab-content">
        {tabs?.map((tab: any) => {
          if (tab.id === activeTab && tab.content) {
            return (
              <div key={tab.id}>
                {tab.content}
              </div>
            );
          }
          return null;
        })}
      </div>
    </S.ItemWrapper>
  );
}

export default Tabs;
